import React from 'react';
import { motion } from 'framer-motion';

const AchievementCard = ({ achievement, isAchieved, language, index }) => {
  const daysText = language === 'zh' ? '天' : 'days';
  
  const badgeClass = isAchieved ? 
    (achievement.special ? 'achievement-badge achieved super-special animate-glow' : 'achievement-badge achieved') : 
    'achievement-badge locked';
  
  const cardClass = isAchieved ? 
    (achievement.special ? 'special-achievement achievement-card achieved' : 'achievement-card achieved') : 
    'achievement-card locked';
  
  const bgClass = isAchieved && achievement.special ? 
    'bg-gradient-to-r from-amber-50 to-white dark:from-gray-700 dark:to-gray-750 animate-bg-shift' : 
    'bg-white dark:bg-gray-750';
  
  const shadowClass = isAchieved ? 
    (achievement.special ? 'shadow-md hover:shadow-xl' : 'shadow-sm hover:shadow-md') : 
    'shadow-sm';
  
  const textColor = isAchieved ? 
    (achievement.special ? 'text-love-600 dark:text-love-400' : 'text-love-600 dark:text-love-300') : 
    'text-gray-500 dark:text-gray-400';
  
  const descColor = isAchieved ? 
    'text-gray-700 dark:text-gray-300' : 
    'text-gray-500 dark:text-gray-400';
  
  const daysColor = isAchieved ? 
    (achievement.special ? 'text-amber-600 dark:text-amber-400 font-bold' : 'text-love-500 dark:text-love-400') : 
    'text-gray-400 dark:text-gray-500';

  return (
    <motion.div
      className={`${cardClass} ${bgClass} p-3 rounded-lg border ${isAchieved ? 'border-love-200 dark:border-love-800' : 'border-gray-200 dark:border-gray-700'} ${shadowClass} transition-all duration-300`}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.05 }}
      whileHover={{ scale: 1.02 }}
    >
      <div className="flex items-center mb-2">
        <div className={`${badgeClass} mr-3`}>
          <span className="emoji">{achievement.icon}</span>
        </div>
        <div>
          <h3 className={`font-medium text-sm ${textColor}`}>{achievement.name}</h3>
          <p className={`text-xs ${descColor}`}>{achievement.description}</p>
        </div>
      </div>
      <div className={`text-xs text-right ${daysColor}`}>
        {achievement.days} {daysText}
      </div>
    </motion.div>
  );
};

export default AchievementCard;